import type { PartnerCockpitOfferRequestDetail } from '@houzy/schemas/partner-cockpit/offer-requests';
import { queryOptions, useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';

import { fetchOfferRequestDetail } from './offerRequestsApi';

type DetailQueryKey = readonly ['offerRequests', 'detail', string];

export function offerRequestDetailQueryKey(offerRequestLeadUuid: string): DetailQueryKey {
    return ['offerRequests', 'detail', offerRequestLeadUuid] as const;
}

export function offerRequestDetailQueryOptions(
    offerRequestLeadUuid: string,
): UseQueryOptions<PartnerCockpitOfferRequestDetail, Error, PartnerCockpitOfferRequestDetail, DetailQueryKey> {
    return queryOptions({
        queryKey: offerRequestDetailQueryKey(offerRequestLeadUuid),
        queryFn: ({ signal }) => fetchOfferRequestDetail(offerRequestLeadUuid, signal),
    });
}

export function useOfferRequestDetail(offerRequestLeadUuid: string): UseQueryResult<PartnerCockpitOfferRequestDetail> {
    return useQuery(offerRequestDetailQueryOptions(offerRequestLeadUuid));
}
